import { render, staticRenderFns } from "./FormTopicPicker.vue?vue&type=template&id=c76a0e72&"
import script from "./FormTopicPicker.vue?vue&type=script&lang=ts&"
export * from "./FormTopicPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports